import classnames from 'classnames';
import React, { useCallback, useRef, useState } from 'react';
import ActionCost from './ActionCost';

import ActionCostTooltip from './ActionCostTooltip';

interface Props {
  actionCost?: number,
  children?: React.ReactNode,
  disabled: boolean,
  isWorking?: boolean,
  go?: boolean,
  onClick: () => void,
}

export default function MainButton({
  actionCost,
  children,
  disabled,
  isWorking,
  go,
  onClick,
}: Props) {
  const element = useRef<HTMLButtonElement>(null);
  const [isTooltipActive, setIsTooltipActive] = useState(false);

  const hideTooltip = useCallback(() => setIsTooltipActive(false), []);
  const showTooltip = useCallback(() => setIsTooltipActive(true), []);

  return (
    <button
      className={classnames(
        'js-tt button button--primary button--margin',
        go && 'button--go',
        (isWorking || disabled) && 'button--disabled',
      )}
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
      ref={element}
      type="button"
    >
      {children}
      {!isWorking && <ActionCost cost={actionCost} />}
      <ActionCostTooltip active={isTooltipActive} cost={actionCost} parent={element.current} />
    </button>
  );
}

MainButton.displayName = 'MainButton';
